<xpo-ag-grid>
  <ag-grid-angular [gridOptions]="gridOptions" (gridReady)="onGridReady($event)"></ag-grid-angular>
</xpo-ag-grid>
